import React from 'react';
import './TranscriptSearch.css';

// Shared by desktop and mobile transcript viewers
const TranscriptSearchBar = React.forwardRef(function TranscriptSearchBar(
  { search, placeholder = 'Search transcript', onClose, autoFocus = false, className = '' },
  inputRef
) {
  const { query, setQuery, matchCount, currentMatch, isSearchActive, nextMatch, prevMatch, clearSearch } = search;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (e.shiftKey) prevMatch();
      else nextMatch();
    } else if (e.key === 'Escape') {
      clearSearch();
      if (onClose) onClose();
      else e.target.blur();
    }
  };

  return (
    <div className={`transcript-search ${className}`} role="search">
      <svg className="transcript-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        ref={inputRef}
        type="search"
        className="transcript-search-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoFocus={autoFocus}
        enterKeyHint="search"
        aria-label="Search transcript"
      />
      {isSearchActive && (
        <span className="transcript-search-count" aria-live="polite">
          {matchCount ? `${currentMatch + 1} of ${matchCount}` : 'No matches'}
        </span>
      )}
      <button
        type="button"
        className="transcript-search-btn"
        onClick={prevMatch}
        disabled={!matchCount}
        title="Previous match (Shift+Enter)"
        aria-label="Previous match"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="18,15 12,9 6,15" />
        </svg>
      </button>
      <button
        type="button"
        className="transcript-search-btn"
        onClick={nextMatch}
        disabled={!matchCount}
        title="Next match (Enter)"
        aria-label="Next match"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </button>
      {(onClose || query) && (
        <button
          type="button"
          className="transcript-search-btn"
          onClick={() => {
            clearSearch();
            onClose?.();
          }}
          title="Clear search (Esc)"
          aria-label="Clear search"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
});

export default TranscriptSearchBar;
